import React, { useContext } from 'react';
import classnames from 'classnames';
import { SubscriptionPurchaseFTUEContext } from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import SubscriptionPurchaseFTUE from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUE';
import DeviationFullView from '../../DeviationViews/Full';
import DuperbrowsePaddles from '../../Duperbrowse/DuperbrowsePaddles';
import { useDeviationViewContext } from '../../Context';
import SubscriptionLockLitFTUE from '../../Tier/ftue/SubscriptionLockLitFTUE';
import StageContainer from '../_partials/StageContainer';
import StageBackground from '../../DeviationBackground/StageBackground';
import s from './DesktopTextualArtStage.scss';
var DesktopTextualArtStage = function (_a) {
    var deviation = _a.deviation, className = _a.className;
    var _b = useDeviationViewContext(), isFullscreen = _b.isFullscreen, isTheater = _b.isTheater;
    var isSubscriptionPurchaseFTUEBeingShown = !!useContext(SubscriptionPurchaseFTUEContext);
    if (isFullscreen) {
        return (React.createElement(StageContainer, { className: classnames(s['root'], s['fullscreen'], className) },
            React.createElement("div", { className: s['scroll-content-wrap'] },
                React.createElement(StageBackground, { deviation: deviation }),
                React.createElement(DeviationFullView, { deviation: deviation })),
            React.createElement(DuperbrowsePaddles, { className: s['duperbrowse'] }),
            React.createElement("div", { className: s['fade'] })));
    }
    return (React.createElement(StageContainer, { className: classnames(s['root'], isTheater && s['theater'], className) },
        React.createElement(DeviationFullView, { deviation: deviation }),
        React.createElement("div", { className: s['stage-box'] },
            React.createElement(DuperbrowsePaddles, { className: s['duperbrowse'] })),
        React.createElement(SubscriptionLockLitFTUE, { deviation: deviation }),
        isSubscriptionPurchaseFTUEBeingShown && React.createElement(SubscriptionPurchaseFTUE, null)));
};
DesktopTextualArtStage.displayName = 'DesktopTextualArtStage';
export default DesktopTextualArtStage;
//# sourceMappingURL=DesktopTextualArtStage.js.map